// ==============================|| AUTHX THEME - TYPOGRAPHY (Inter, compact like ERPNext) ||============================== //

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: { fontWeight: 650, fontSize: '2.125rem', lineHeight: 1.2, letterSpacing: '-0.02em' },
    h2: { fontWeight: 650, fontSize: '1.75rem', lineHeight: 1.25, letterSpacing: '-0.015em' },
    h3: { fontWeight: 650, fontSize: '1.4rem', lineHeight: 1.3, letterSpacing: '-0.01em' },
    h4: { fontWeight: 650, fontSize: '1.2rem', lineHeight: 1.35, letterSpacing: '-0.01em' },
    h5: { fontWeight: 600, fontSize: '1rem', lineHeight: 1.45 },
    h6: { fontWeight: 600, fontSize: '0.875rem', lineHeight: 1.5 },
    caption: { fontWeight: 400, fontSize: '0.75rem', lineHeight: 1.5 },
    body1: { fontSize: '0.875rem', lineHeight: 1.55 },
    body2: { fontSize: '0.8125rem', lineHeight: 1.55 },
    subtitle1: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.5 },
    subtitle2: { fontSize: '0.8125rem', fontWeight: 500, lineHeight: 1.5 },
    overline: { lineHeight: 1.66, letterSpacing: '0.06em', fontSize: '0.6875rem', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 }
  };
}
